/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
 */

import UAParser from 'ua-parser-js';

/**
 * Guess what browser & OS the software is running in
 * @param {string} [userAgentString] - User agent string. It is `global.navigator.userAgent` if it is not provided.
 * @returns {browser} parsed browser data
 */
export function getBrowserDetails(userAgentString) {
    const parser = new UAParser(userAgentString);
    const result = parser.getResult();
    return {
        browser: {
            name: (result.browser.name || '').toLowerCase(),
            version: result.browser.version
        },
        os: {
            name: (result.os.name || '').toLowerCase(),
            version: result.os.version
        },
        userAgentString: result.ua
    };
}
